<template>
  <div class="resource-store-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('resourceStoreManage.page.title')" :subtitle="$t('resourceStoreManage.page.subtitle')">
      <template #extra>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddResourceStoreModal"
          v-if="hasPrivilege('502022081709270004')">
          {{ $t('resourceStoreManage.add') }}
        </el-button>
        <el-button size="small" icon="el-icon-plus" @click="jump2InPage" v-if="hasPrivilege('502021042137960001')">
          {{ $t('resourceStoreManage.directPurchase') }}
        </el-button>
        <el-button size="small" icon="el-icon-plus" @click="jump2OutPage" v-if="hasPrivilege('502021042137960001')">
          {{ $t('resourceStoreManage.directOut') }}
        </el-button>
        <el-button size="small" icon="el-icon-upload" @click="importResourceStoreModal"
          v-if="hasPrivilege('502022081750470005')">
          {{ $t('resourceStoreManage.import') }}
        </el-button>
        <el-button size="small" icon="el-icon-download" @click="exportExcel">
          {{ $t('resourceStoreManage.export') }}
        </el-button>
        <el-button v-if="resourceStoreManageInfo.conditions.flag == '1'" size="small" icon="el-icon-back" @click="goBack">
          {{ $t('resourceStoreManage.back') }}
        </el-button>
      </template>
    </ds-page-header>

    <el-row :gutter="16">
      <el-col :xs="24" :sm="6" :md="5" :lg="4">
        <div class="ds-panel ds-panel--padded">
          <div class="ds-panel__header">
            <span class="ds-panel__title">{{ $t('resourceStoreManage.typeTree') }}</span>
          </div>
          <div class="type-actions">
            <el-button type="primary" size="mini" @click="openAddResourceStoreTypeModal(1)">
              {{ $t('resourceStoreManage.addFirstLevel') }}
            </el-button>
            <el-button type="primary" size="mini" @click="openAddResourceStoreTypeModal(2)">
              {{ $t('resourceStoreManage.addSecondLevel') }}
            </el-button>
            <el-button size="mini" @click="openEditResourceStoreTypeModel">
              {{ $t('resourceStoreManage.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="openDeleteResourceStoreTypeModel">
              {{ $t('resourceStoreManage.delete') }}
            </el-button>
          </div>
          <resource-store-type-tree ref="resourceStoreTypeTree" @switchParent="switchParent" @switchRst="switchRst" />
        </div>
      </el-col>
      <el-col :xs="24" :sm="18" :md="19" :lg="20">
        <!-- (2) SearchPanel -->
        <ds-search-panel>
          <el-row :gutter="16">
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-select v-model="resourceStoreManageInfo.conditions.shId" clearable class="w-full"
                :placeholder="$t('resourceStoreManage.selectStorehouse')">
                <el-option :label="$t('resourceStoreManage.selectStorehouse')" value=""></el-option>
                <el-option v-for="(item, index) in resourceStoreManageInfo.storehouses" :key="index"
                  :label="item.shName" :value="item.shId"></el-option>
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input :placeholder="$t('resourceStoreManage.enterResourceName')" clearable class="w-full"
                v-model.trim="resourceStoreManageInfo.conditions.resName" @keyup.enter.native="queryResourceStoreMethod" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-input :placeholder="$t('resourceStoreManage.enterResourceCode')" clearable class="w-full"
                v-model.trim="resourceStoreManageInfo.conditions.resCode" @keyup.enter.native="queryResourceStoreMethod" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-select v-model="resourceStoreManageInfo.conditions.rssId" clearable class="w-full"
                :placeholder="$t('resourceStoreManage.selectSpec')">
                <el-option :label="$t('resourceStoreManage.selectSpec')" value=""></el-option>
                <el-option v-for="(item, index) in resourceStoreManageInfo.resourceStoreSpecifications" :key="index"
                  :label="item.specName" :value="item.rssId"></el-option>
              </el-select>
            </el-col>
            <el-col v-show="moreCondition" :xs="24" :sm="12" :md="8" :lg="6">
              <el-select v-model="resourceStoreManageInfo.conditions.isFixed" clearable class="w-full"
                :placeholder="$t('resourceStoreManage.selectIsFixed')">
                <el-option :label="$t('resourceStoreManage.selectIsFixed')" value=""></el-option>
                <el-option v-for="(item, index) in resourceStoreManageInfo.isFixeds" :key="index" :label="item.name"
                  :value="item.statusCd"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <template #actions>
            <el-button type="primary" icon="el-icon-search" @click="queryResourceStoreMethod">
              {{ $t('resourceStoreManage.query') }}
            </el-button>
            <el-button icon="el-icon-refresh-left" @click="resetResourceStoreMethod">
              {{ $t('resourceStoreManage.reset') }}
            </el-button>
            <el-button type="text" @click="moreCondition = !moreCondition">
              {{ moreCondition ? $t('resourceStoreManage.hideMore') : $t('resourceStoreManage.more') }}
            </el-button>
          </template>
        </ds-search-panel>

        <!-- (3)(4)(6) Toolbar + DataTable + PaginationBar -->
        <div class="ds-panel">
          <ds-toolbar :total="pagination.total" :density="density" :show-column-setting="false"
            :show-refresh="true" @update:density="density = $event" @refresh="listResourceStores">
            <template #left>
              <span class="ds-panel__title">{{ $t('resourceStoreManage.resourceInfo') }}</span>
            </template>
          </ds-toolbar>

          <ds-data-table :data="resourceStoreManageInfo.resourceStores" :loading="loading" :error="hasError"
            :error-message="errorMessage" :density="density" border
            :empty-description="$t('resourceStoreManage.page.empty')" @retry="listResourceStores">
            <el-table-column prop="resId" :label="$t('resourceStoreManage.resourceId')" align="center" width="100">
              <template slot-scope="scope">
                <span class="ds-num">{{ scope.row.resId || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('resourceStoreManage.resourceNameCode')" align="center" min-width="170">
              <template slot-scope="scope">
                {{ scope.row.resName }}({{ scope.row.resCode }})
              </template>
            </el-table-column>
            <el-table-column prop="shName" :label="$t('resourceStoreManage.storeName')" align="center" min-width="110" />
            <el-table-column :label="$t('resourceStoreManage.resourceType')" align="center" min-width="140">
              <template slot-scope="scope">
                {{ scope.row.parentRstName }}{{ scope.row.rstName ? ' > ' + scope.row.rstName : '' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('resourceStoreManage.resourceSpec')" align="center" width="110">
              <template slot-scope="scope">
                {{ scope.row.rssName ? scope.row.rssName : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="isFixedName" :label="$t('resourceStoreManage.fixedResource')" align="center" width="90">
              <template slot-scope="scope">
                <ds-status-tag size="sm" :type="scope.row.isFixed === 'Y' ? 'info' : 'muted'"
                  :label="scope.row.isFixedName || '-'" />
              </template>
            </el-table-column>
            <el-table-column :label="$t('resourceStoreManage.referencePrice')" align="center" width="110">
              <template slot-scope="scope">
                <span class="ds-num">{{ formatMoney(scope.row.price) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('resourceStoreManage.chargeStandard')" align="center" min-width="150">
              <template slot-scope="scope">
                <span class="ds-num">{{ scope.row.outHighPrice == scope.row.outLowPrice
                  ? '￥' + scope.row.outLowPrice
                  : '￥' + scope.row.outLowPrice + '-￥' + scope.row.outHighPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('resourceStoreManage.stock')" align="center" width="110">
              <template slot-scope="scope">
                <span class="ds-num">{{ scope.row.stock }}{{ scope.row.unitCodeName }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('resourceStoreManage.minUnit')" align="center" min-width="130">
              <template slot-scope="scope">
                <span class="ds-num">1{{ scope.row.unitCodeName }}={{ scope.row.miniUnitStock }}{{ scope.row.miniUnitCodeName }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('resourceStoreManage.minTotal')" align="center" width="110">
              <template slot-scope="scope">
                <span class="ds-num">{{ scope.row.miniStock }}{{ scope.row.miniUnitCodeName }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('resourceStoreManage.avgPrice')" align="center" width="110">
              <template slot-scope="scope">
                <span class="ds-num">{{ scope.row.averagePrice ? '￥' + scope.row.averagePrice : '￥0' }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('resourceStoreManage.totalPrice')" align="center" width="90">
              <template slot-scope="scope">
                <el-link type="primary" @click="queryTotalPrice(scope.row)">{{ $t('resourceStoreManage.query') }}</el-link>
              </template>
            </el-table-column>
            <el-table-column :label="$t('resourceStoreManage.operation')" align="center" width="200" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" v-if="hasPrivilege('502022081701700001')"
                  @click="openEditResourceStoreModel(scope.row)">
                  {{ $t('resourceStoreManage.edit') }}
                </el-button>
                <el-button size="mini" type="danger" v-if="hasPrivilege('502022081741410002')"
                  @click="openDeleteResourceStoreModel(scope.row)">
                  {{ $t('resourceStoreManage.delete') }}
                </el-button>
                <el-button size="mini" @click="toResourceStoreDetail(scope.row)">
                  {{ $t('resourceStoreManage.detail') }}
                </el-button>
              </template>
            </el-table-column>
          </ds-data-table>

          <div class="ds-summary">
            <span><b>{{ $t('resourceStoreManage.subTotal') }}</b> {{ $t('resourceStoreManage.totalPrice') }}：<span class="ds-num">{{ resourceStoreManageInfo.subTotalPrice }}</span> {{ $t('resourceStoreManage.yuan') }}</span>
            <span class="ds-summary__gap"><b>{{ $t('resourceStoreManage.grandTotal') }}</b> {{ $t('resourceStoreManage.totalPrice') }}：<span class="ds-num">{{ resourceStoreManageInfo.highTotalPrice }}</span> {{ $t('resourceStoreManage.yuan') }}</span>
          </div>

          <ds-pagination-bar :page="pagination.current" :size="pagination.size" :total="pagination.total"
            :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" @current-change="handlePageChange" />
        </div>
      </el-col>
    </el-row>

    <!-- 子组件 -->
    <add-resource-store ref="addResourceStore" @success="handleResourceStoreSuccess" />
    <edit-resource-store ref="editResourceStore" @success="handleResourceStoreSuccess" />
    <delete-resource-store ref="deleteResourceStore" @success="handleResourceStoreSuccess" />
    <resource-store-times ref="resourceStoreTimes" />
    <import-resource-store ref="importResourceStore" @success="handleResourceStoreSuccess" />
    <add-resource-store-type ref="addResourceStoreType" @success="handleResourceStoreTypeSuccess" />
    <edit-resource-store-type ref="editResourceStoreType" @success="handleResourceStoreTypeSuccess" />
    <delete-resource-store-type ref="deleteResourceStoreType" @success="handleResourceStoreTypeSuccess" />
  </div>
</template>

<script>
import { getDict, getCommunityId } from '@/api/community/communityApi'
import { listResourceStores, exportData, listResourceStoreSpecifications, listStorehouses, listResourceStoreTypes } from '@/api/resource/resourceStoreManageApi'
import ResourceStoreTypeTree from '@/components/resource/resourceStoreTypeTree'
import AddResourceStore from '@/components/resource/addResourceStore'
import EditResourceStore from '@/components/resource/editResourceStore'
import DeleteResourceStore from '@/components/resource/deleteResourceStore'
import ResourceStoreTimes from '@/components/resource/resourceStoreTimes'
import ImportResourceStore from '@/components/resource/importResourceStore'
import AddResourceStoreType from '@/components/resource/addResourceStoreType'
import EditResourceStoreType from '@/components/resource/editResourceStoreType'
import DeleteResourceStoreType from '@/components/resource/deleteResourceStoreType'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsSearchPanel from '@/components/ds/ds-search-panel.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'
import { formatMoney } from '@/utils/format'

export default {
  name: 'ResourceStoreManageList',
  components: {
    ResourceStoreTypeTree,
    AddResourceStore,
    EditResourceStore,
    DeleteResourceStore,
    ResourceStoreTimes,
    ImportResourceStore,
    AddResourceStoreType,
    EditResourceStoreType,
    DeleteResourceStoreType,
    DsPageHeader,
    DsSearchPanel,
    DsToolbar,
    DsDataTable,
    DsPaginationBar,
    DsStatusTag
  },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      moreCondition: false,
      resourceStoreManageInfo: {
        resourceStores: [],
        total: 0,
        records: 1,
        subTotalPrice: 0.0,
        highTotalPrice: 0.0,
        isFixeds: [],
        conditions: {
          resId: '',
          resName: '',
          resCode: '',
          shId: '',
          parentRstId: '',
          rstId: '',
          rssId: '',
          isFixed: '',
          flag: '',
          userId: '',
          communityId: '',
          page: 1,
          row: 10
        },
        curType: {},
        storehouses: [],
        resourceStoreSpecifications: []
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.resourceStoreManageInfo.conditions.communityId = this.communityId
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))

    const flag = this.$route.query.flag
    if (flag) {
      this.resourceStoreManageInfo.conditions.flag = flag
    }

    this.initData()
  },
  methods: {
    formatMoney(v) { return formatMoney(v) },
    async initData() {
      await this.loadDictData()
      await this.listResourceStores()
      await this.listStorehouses()
      await this.listResourceStoreSpecifications()
    },

    async loadDictData() {
      try {
        const data = await getDict('resource_store', 'is_fixed')
        this.resourceStoreManageInfo.isFixeds = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },

    async listResourceStores() {
      this.loading = true
      this.hasError = false
      try {
        this.resourceStoreManageInfo.conditions.page = this.pagination.current
        this.resourceStoreManageInfo.conditions.row = this.pagination.size

        const response = await listResourceStores(this.resourceStoreManageInfo.conditions)
        const data = response

        this.resourceStoreManageInfo.resourceStores = data.resourceStores || []
        this.resourceStoreManageInfo.subTotalPrice = data.subTotal || 0
        this.resourceStoreManageInfo.highTotalPrice = data.totalPrice || 0
        this.pagination.total = data.total || 0
      } catch (error) {
        console.error('获取物品列表失败:', error)
        this.hasError = true
        this.errorMessage = this.$t('common.loadError')
      } finally {
        this.loading = false
      }
    },

    async listStorehouses() {
      try {
        const params = {
          communityId: this.communityId,
          page: 1,
          row: 100
        }
        const response = await listStorehouses(params)
        this.resourceStoreManageInfo.storehouses = response.data || []
      } catch (error) {
        console.error('获取仓库列表失败:', error)
      }
    },

    async listResourceStoreSpecifications() {
      try {
        const params = {
          communityId: this.communityId,
          page: 1,
          row: 100
        }
        const response = await listResourceStoreSpecifications(params)
        this.resourceStoreManageInfo.resourceStoreSpecifications = response.data || []
      } catch (error) {
        console.error('获取物品规格列表失败:', error)
      }
    },

    handlePageChange(currentPage) {
      this.pagination.current = currentPage
      this.listResourceStores()
    },

    handleSizeChange(size) {
      this.pagination.size = size
      this.pagination.current = 1
      this.listResourceStores()
    },

    queryResourceStoreMethod() {
      this.pagination.current = 1
      this.listResourceStores()
    },

    resetResourceStoreMethod() {
      this.resourceStoreManageInfo.conditions = {
        ...this.resourceStoreManageInfo.conditions,
        resId: '',
        resName: '',
        resCode: '',
        shId: '',
        rstId: '',
        parentRstId: '',
        rssId: '',
        isFixed: ''
      }
      this.pagination.current = 1
      this.listResourceStores()
    },

    openAddResourceStoreModal() {
      this.$refs.addResourceStore.open()
    },

    openEditResourceStoreModel(row) {
      this.$refs.editResourceStore.open(row)
    },

    openDeleteResourceStoreModel(row) {
      this.$refs.deleteResourceStore.open(row)
    },

    openAddResourceStoreTypeModal(level) {
      let _curType = this.resourceStoreManageInfo.curType;
      if (level == 1) {
        this.resourceStoreManageInfo.curType = {}
        this.$refs.addResourceStoreType.open('')
        return;
      }
      if (!_curType || !_curType.rstId) {
        this.$message.error(this.$t('resourceStoreManage.selectType'))
        return;
      }
      this.$refs.addResourceStoreType.open(_curType.rstId)
    },

    openDeleteResourceStoreTypeModel() {
      let _curType = this.resourceStoreManageInfo.curType;
      if (!_curType.rstId) {
        return;
      }
      this.$refs.deleteResourceStoreType.open(_curType)
    },

    openEditResourceStoreTypeModel() {
      let _curType = this.resourceStoreManageInfo.curType;
      if (!_curType.rstId) {
        this.$message.error(this.$t('resourceStoreManage.selectType'))
        return;
      }
      this.$refs.editResourceStoreType.open(_curType)
    },

    importResourceStoreModal() {
      this.$refs.importResourceStore.open()
    },

    queryTotalPrice(row) {
      this.$refs.resourceStoreTimes.open(row)
    },

    switchParent(param) {
      console.log(param)
      this.resourceStoreManageInfo.conditions.parentRstId = param.parentRstId
      this.resourceStoreManageInfo.conditions.rstId = ''
      this.listResourceStoreType(param.parentRstId)
      this.listResourceStores()
    },

    switchRst(param) {
      this.resourceStoreManageInfo.conditions.parentRstId = ''
      this.resourceStoreManageInfo.conditions.rstId = param.rstId
      this.listResourceStoreType(param.rstId)
      this.listResourceStores()
    },
    async listResourceStoreType(rstId) {
      const { data } = await listResourceStoreTypes({ page: 1, row: 1, rstId: rstId, communityId: getCommunityId() })
      this.resourceStoreManageInfo.curType = data[0]
    },

    handleResourceStoreSuccess() {
      this.listResourceStores()
    },

    handleResourceStoreTypeSuccess() {
      this.$refs.resourceStoreTypeTree.refreshTree()
    },

    async exportExcel() {
      try {
        this.resourceStoreManageInfo.conditions.pagePath = 'resourceStoreManage'
        const res = await exportData(this.resourceStoreManageInfo.conditions)
        this.$message.success(this.$t('common.operationSuccess'))
        if (res && res.code === 0) {
          window.open('/#/pages/property/downloadTempFile?tab=下载中心')
        }
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error(this.$t('resourceStoreManage.exportFailed'))
      }
    },

    jump2InPage() {
      this.$router.push({
        path: '/views/resource/addPurchaseApply',
        query: {
          resOrderType: '10000',
          purchaseSwitch: 'OFF'
        }
      })
    },

    jump2OutPage() {
      this.$router.push({
        path: '/views/resource/addItemOut',
        query: {
          resOrderType: '20000',
          from: 'resourceStore'
        }
      })
    },

    toResourceStoreDetail(row) {
      void row
      const resource = row || {}
      window.open(`/#/views/resource/resourceDetail?resId=${resource.resId}`)
    },

    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.resource-store-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &--padded {
    padding: var(--ds-spacing-lg);
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: var(--ds-spacing-md);
    margin-bottom: var(--ds-spacing-md);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

.type-actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ds-spacing-xs);
  margin-bottom: var(--ds-spacing-md);
}

.ds-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-spacing-md);
  padding: var(--ds-spacing-sm) var(--ds-spacing-lg);
  font-size: var(--ds-font-size-sm);
  color: var(--ds-gray-600);
  border-top: 1px solid var(--ds-gray-200);

  &__gap {
    margin-left: var(--ds-spacing-lg);
  }
}

.w-full {
  width: 100%;
}
</style>
